import React from "react";
import Flickity from "react-flickity-component";
import { Link } from "react-router-dom";

const CategoryCarousel = ({ categories = [], collectionName = "" }) => {
  const flickityOptions = {
    initialIndex: 0,
    freeScroll: true,
    wrapAround: false,
    pageDots: false,
    prevNextButtons: true,
  };

  return (
    <div className="grid grid-cols-12 gap-4 md:my-12 my-8">
      <div className="md:col-span-3 col-span-4 flex justify-center items-center">
        <h1 className="text-2xl font-medium md:me-12 me-3">
          {collectionName ? collectionName.toUpperCase() : "COLLECTION"}
        </h1>
      </div>
      <div className="md:col-span-9 flow-root col-span-8 overflow-hidden">
        {categories && categories.length > 0 ? (
          <Flickity className="carousel float-left" elementType="div" options={flickityOptions}>
            {categories.map((category, index) => (
              <div className="text-center shrink-0  h-40 w-30 p-1 mx-1 line-clamp-2 overflow-hidden text-ellipsis" key={index}>
                <Link to={`/collections/${collectionName}&attribute=${category.name}`}>
                  <div className="w-20 h-20 rounded-full overflow-hidden mx-auto"> 
                    <img
                      src={category.image || "https://via.placeholder.com/150"}
                      alt={category.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mt-2 text-sm text-gray-700 line-clamp-2 overflow-hidden text-ellipsis">{category.name}</p>
                </Link>
              </div>
            ))}
          </Flickity>
        ) : (
          <p className="text-center text-gray-500">No categories available</p>
        )}
      </div>
    </div>
  );
};

export default CategoryCarousel;
